export enum DisclaimerPosition {
    BELOW_FOOTER_BUTTON = 'BELOW_FOOTER_BUTTON',
    ABOVE_FOOTER_BUTTON = 'ABOVE_FOOTER_BUTTON'
}
